import { render, staticRenderFns } from "./PageCheckoutItemsBelowItemsHook.vue?vue&type=template&id=53f21c7b&"
import script from "./PageCheckoutItemsBelowItemsHook.js?vue&type=script&lang=js&"
export * from "./PageCheckoutItemsBelowItemsHook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports